module.exports = __webpack_public_path__ + "img/2-3.e5f4ec20.jpg";